module.exports = __webpack_public_path__ + "media/assets/images/account/fb-connected-44af618330b9239f6477dc14514f159a.png";